import {
  V2ListQuestionnairesForAccountApiArg,
  useV2ListQuestionnairesForAccountQuery,
} from "@generated";
import type { Questionnaire } from "../types";

export interface UseQuestionnairesListArgs {
  page?: V2ListQuestionnairesForAccountApiArg["page"];
  filter?: V2ListQuestionnairesForAccountApiArg["filter"];
}

export interface QuestionnairesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useQuestionnairesList = ({
  page,
  filter,
}: UseQuestionnairesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListQuestionnairesForAccountQuery(
      { page, filter },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Questionnaire[] = (data?.data ?? []).map((q: any) => ({
    id: String(q.id),
    name: q.attributes?.name ?? "",
    published: !!q.attributes?.published,
    tagList: q.attributes?.["tag-list"] ?? [],
  }));

  const pageMeta: QuestionnairesListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useQuestionnairesList;
